import { Box, Typography } from '@mui/material';
import type { BetBuilderMyBetsGroup } from '../../../../types/betBuilder';
import { useBetBuilderItem } from '../../../../hooks/useBetBuilderItem';
import useLocalization from '../../../../hooks/useLocalization';
import OddsDisplay from '../../../atoms/OddsDisplay';
import BetBuilderLegList from '../../../molecules/BetBuilderLegList';

const styles = {
  root: {
    display: 'grid',
    alignItems: 'end',
    gridTemplateColumns: 'minmax(0, 1fr) auto',
    borderRadius: 3,
    border: '1px solid',
    borderColor: 'divider',
    backgroundColor: 'neutral.600',
    overflow: 'hidden',
  },
  betCardBody: {
    minWidth: 0,
    px: 1.25,
    py: 1,
    display: 'grid',
    alignContent: 'center',
    gap: 0.625,
  },
  betMeta: {
    minWidth: 0,
    display: 'grid',
    gap: 0.25,
  },
  betTitle: {
    typography: 'body2',
    fontWeight: 800,
    color: 'text.primary',
    textAlign: 'left',
  },
  betEvent: {
    typography: 'subtitle3',
    color: 'neutral.200',
  },
  legList: {
    mt: 0.25,
  },
  oddsColumn: {
    px: 1.25,
    py: 1,
    display: 'grid',
    justifyItems: 'end',
    alignContent: 'end',
  },
  oddsValue: {
    typography: 'body2',
    fontWeight: 800,
    color: 'primary.main',
    textAlign: 'right',
  },
} as const;

type NeobetReofferedBetBuilderItemProps = {
  group: BetBuilderMyBetsGroup;
  testId?: string;
};

const NeobetReofferedBetBuilderItem = ({ group, testId }: NeobetReofferedBetBuilderItemProps) => {
  const { legs } = useBetBuilderItem({ type: 'myBets', group });
  const { t } = useLocalization();

  return (
    <Box sx={styles.root} data-testid={testId ?? `neobet-reoffered-bet-builder-item-${group.id}`}>
      <Box sx={styles.betCardBody}>
        <Box sx={styles.betMeta}>
          <Typography sx={styles.betTitle}>{t('betBuilder')}</Typography>
          <Typography sx={styles.betEvent}>{group.event?.name}</Typography>
        </Box>

        <Box sx={styles.legList}>
          <BetBuilderLegList legs={legs} variant='neobet' />
        </Box>
      </Box>

      <Box sx={styles.oddsColumn}>
        <OddsDisplay value={group.odds} sx={styles.oddsValue} />
      </Box>
    </Box>
  );
};

export default NeobetReofferedBetBuilderItem;
